export default function LoadingScreen(props) {
    let loadingText = props.loadingtext !== undefined ? props.loadingtext : "",
        subText = props.subtext !== undefined ? props.subtext : "",
        isHidden = props.ishidden !== undefined ? props.ishidden : false,
        loadingColor = props.loadingcolor !== undefined ? props.loadingcolor : "blue-500",
        finalColor = props.finalcolor !== undefined ? props.finalcolor : "transparent";

    let isHiddenClass = isHidden ? "hidden" : "block";
    return (
        <div className={isHiddenClass + " flex flex-col items-start justify-center w-full h-full grow overflow-hidden"} aria-hidden={isHidden ? "true" : "false"}>
            <div className="flex flex-col w-full h-full items-center justify-center px-4 overflow-hidden">
                {/* <div className="w-full my-5">
                    <div className="flex flex-col p-4 md:p-4 space-y-1 justify-between bg-red-200 rounded-xl mt-5">
                        <h2 className="text-md font-bold text-red-800">Whoops, you've reached a dead end</h2>
                        <h2 className="text-sm font-normal text-red-800 p-0 mt-0">df</h2>
                    </div>
                </div> */}

                {/* <div class="lds-grid">
                    <div className="bg-blue-600"></div>
                    <div className="bg-blue-600"></div>
                    <div className="bg-blue-600"></div>
                    <div className="bg-blue-600"></div>
                    <div className="bg-blue-600"></div>
                    <div className="bg-blue-600"></div>
                    <div className="bg-blue-600"></div>
                    <div className="bg-blue-600"></div>
                    <div className="bg-blue-600"></div>
                </div> */}
                <div className="relative">
                    {/* <div className={"lds-dual-ring after:border-" + loadingColor + " after:border-t-transparent after:border-b-transparent"}></div> */}
                    <div className={"transition-colors duration-300 ease-in-out lds-dual-ring after:border-" + loadingColor + " after:border-t-" + finalColor + " after:border-b-" + finalColor}></div>
                    <div className="absolute w-[60px] h-[60px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                        <img 
                            src="/img/card_logo_color.svg" 
                            alt="scan-logo" 
                            className="w-full h-full object-contain" />
                    </div>
                </div>
                <h2 className="font-bold text-xl mt-4 text-center select-none text-blue-600">{loadingText}</h2>
                <h2 className="font-bold text-md mt-4 text-center select-none text-blue-600">{subText}</h2>

                {/* <a href="/" className="transition-color ease-in-out duration-100 w-full max-w-[300px] text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-1xl px-5 py-2.5 mt-[60px] text-center">
                    Take Me Home!
                </a> */}

            </div>
        </div>
    )
}